module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择社区"
    },
    on: {
      "change": _vm.communityHandle
    },
    model: {
      value: (_vm.currentCommunity),
      callback: function($$v) {
        _vm.currentCommunity = $$v
      },
      expression: "currentCommunity"
    }
  }, _vm._l((_vm.communityData), function(item) {
    return _c('el-option', {
      key: item.community_id,
      attrs: {
        "label": item.community_name,
        "value": item.community_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号/订单号"
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_vm._l((_vm.orderStatusList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.value
      }
    })
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 220
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-card', {
          staticClass: "section-body",
          attrs: {
            "shadow": "always"
          }
        }, [_c('div', {
          staticClass: "clearfix",
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [(_vm.communityObj[props.row.shop_id]) ? _c('el-row', {
          attrs: {
            "gutter": 24
          }
        }, [_c('el-col', {
          attrs: {
            "md": 8,
            "lg": 6
          }
        }, [_vm._v("社区名称：" + _vm._s(_vm.communityObj[props.row.shop_id].community_name))]), _vm._v(" "), _c('el-col', {
          attrs: {
            "md": 8,
            "lg": 6
          }
        }, [_vm._v("团长名称：" + _vm._s(_vm.communityObj[props.row.shop_id].leader_name))]), _vm._v(" "), _c('el-col', {
          attrs: {
            "md": 8,
            "lg": 6
          }
        }, [_vm._v("团长手机号：" + _vm._s(_vm.communityObj[props.row.shop_id].leader_mobile))])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": props.row.items
          }
        }, [_c('el-table-column', {
          staticClass: "goods-img",
          attrs: {
            "prop": "pic",
            "label": "图片",
            "min-width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_c('img', {
                attrs: {
                  "width": "50",
                  "src": _vm.wximageurl + scope.row.pic,
                  "alt": scope.row.item_name
                }
              })])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "item_name",
            "min-width": "200",
            "label": "名称"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "num",
            "min-width": "50",
            "label": "数量"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "price",
            "min-width": "50",
            "label": "原价"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                 " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.price / 100) + "\n               ")]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "total_fee",
            "min-width": "100",
            "label": "支付金额"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                 " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100) + "\n               ")]
            }
          }], null, true)
        })], 1)], 1)]
      }
    }], null, false, 1861699007)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "width": "160",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2176513052)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "width": "160",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_fee",
      "label": "金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100) + "\n        ")]
      }
    }], null, false, 3868117697)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "width": "110",
      "label": "会员手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_status",
      "label": "订单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_status == 'DONE') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已完成")]) : (scope.row.order_status == 'PAYED') ? _c('el-tag', {
          attrs: {
            "type": "primary",
            "size": "mini"
          }
        }, [_vm._v("待提货")]) : (scope.row.order_status == 'NOTPAY') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未支付")]) : (scope.row.order_status == 'CANCEL') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已取消")]) : (scope.row.order_status == 'REFUND_PROCESS') ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("退款处理中")]) : (scope.row.order_status == 'REFUND_SUCCESS') ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "mini"
          }
        }, [_vm._v("退款成功")]) : (scope.row.order_status == 'REFUND_FAIL') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("退款失败")]) : _vm._e()]
      }
    }], null, false, 1496668324)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "width": "160",
      "label": "社区名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.communityObj[scope.row.shop_id]) ? _c('span', [_vm._v(_vm._s(_vm.communityObj[scope.row.shop_id].community_name))]) : _vm._e()]
      }
    }], null, false, 529501564)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "width": "100",
      "label": "团长姓名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.communityObj[scope.row.shop_id]) ? _c('span', [_vm._v(_vm._s(_vm.communityObj[scope.row.shop_id].leader_name))]) : _vm._e()]
      }
    }], null, false, 4246313300)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('detail'),
              query: {
                orderId: scope.row.order_id,
                resource: '/member/marketing/communityactivity/order',
                params: _vm.params
              }
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 1318397157)
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-380a086f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-380a086f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/activity/orderList.vue
// module id = 2618
// module chunks = 0